// @ts-nocheck
import { graphql } from "gatsby"

import { Box } from "@mui/material"
import { get } from "lodash"

import { mapPlacesToGOData } from "../../helpers/data-mappers"
import PlacesToGoPageView from "../../templates/subpage-places-to-go-view"
import SEOHead from "../head"

export default function PlacesToGoView(props) {
  const placesToGo = get(props, "data.subPage", {})

  if (!placesToGo) {
    return <Box>{"Places to go page not found"}</Box>
  }

  const mappedData = mapPlacesToGOData(placesToGo)

  return (
    <>
      {ComposeHead(props)}
      <PlacesToGoPageView data={mappedData} />
    </>
  )
}

export const ComposeHead = (props) => {
  const { subPage } = props.data
  const metatag = get(subPage, "metatag.items")
  const url = get(subPage, "slug")
  const ImageUrl = get(subPage, "hero.images[0].variants[0].url", "")
  return <SEOHead metas={metatag} url={url} image={ImageUrl} />
}

export const query = graphql`
  query PlacesToGoTemplateQuery($id: String!) {
    subPage(id: { eq: $id }) {
      title
      slug
      id
      metatag {
        items {
          content
          name
        }
      }
      hero {
        ...HeroFragment
      }
      template {
        ... on paragraph__places_to_go {
          id
          suggested_trips {
            ...SuggestedTripsFragment
          }
          text_overview {
            ...TextOverviewFragment
          }
          contact_cta {
            ...ContactCtaFragment
          }
        }
      }
      parent_page {
        ...GeoCountryReferenceFragment
      }
    }
  }
`
